import React from "react";
import { feedback } from "../constants";
import Feedback from "./Feedback";
import { Star } from "lucide-react";

const Testimonials = () => {
  return (
    <section className="py-24 md:py-32 px-6 md:px-10" style={{ background: '#f5f3f0' }}>
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="text-center mb-16">
          <span className="text-xs font-semibold tracking-[0.2em] uppercase" style={{ color: '#712B35' }}>
            Testimonials
          </span>
          <h2 className="text-3xl md:text-4xl font-bold mt-3 mb-3" style={{ color: '#2a2118' }}>
            What Our Clients Say
          </h2>
          <p className="text-base font-light max-w-2xl mx-auto" style={{ color: '#5a524c' }}>
            Real stories from customers who trust our services every day.
          </p>
        </div>

        {/* Testimonials Grid */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {feedback.map((card, index) => (
            <div
              key={card.id}
              className="bg-white rounded-2xl p-8 border border-gray-100 transition-shadow duration-200 hover:shadow-lg"
            >
              {/* Rating */}
              <div className="flex gap-1 mb-4">
                {[...Array(5)].map((_, i) => (
                  <Star key={i} className="w-4 h-4" style={{ color: '#eab308', fill: '#eab308' }} />
                ))}
              </div>

              {/* Content */}
              <div style={{ color: '#4b5563' }}>
                <Feedback {...card} />
              </div>

              {/* Divider */}
              <div className="my-5 w-full h-px" style={{ background: '#f3f4f6' }} />

              {/* Author */}
              <div className="flex items-center gap-3">
                {card.img && (
                  <img
                    src={card.img}
                    alt={card.name}
                    className="w-10 h-10 rounded-full object-cover"
                  />
                )}
                <div>
                  <p className="font-semibold text-sm" style={{ color: '#2a2118' }}>{card.name}</p>
                  <p className="text-xs font-medium" style={{ color: '#712B35' }}>{card.title}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
